/**
 * Centralized API URL configuration for KursAdmin frontend.
 * Import from here instead of duplicating environment detection in each file.
 *
 * Usage:
 *   import { CONTACT_API_URL, COURSE_API_URL, EMAIL_API_URL } from './lib/api-config';
 */

const getEnvironment = () => {
  if (typeof window !== 'undefined' && window.location.hostname.includes('-staging')) {
    return 'staging';
  }
  return process.env.NODE_ENV === 'production' ? 'production' : 'development';
};

export const environment = getEnvironment();

export const CONTACT_API_URL = environment === 'staging'
  ? 'https://kursadmin-contact-api-staging.azurewebsites.net/api'
  : environment === 'production'
    ? 'https://kursadmin-contact-api.azurewebsites.net/api'
    : 'http://localhost:3001/api';

export const COURSE_API_URL = environment === 'staging'
  ? 'https://kursadmin-course-api-staging.azurewebsites.net/api'
  : environment === 'production'
    ? 'https://kursadmin-course-api.azurewebsites.net/api'
    : 'http://localhost:3002/api';

export const EMAIL_API_URL = environment === 'staging'
  ? 'https://kursadmin-email-api-staging.azurewebsites.net/api'
  : environment === 'production'
    ? 'https://kursadmin-email-api.azurewebsites.net/api'
    : 'http://localhost:3003/api';
